import styled from "styled-components";


export const Container = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-top: -1px;
  height: ${({ theme }) => theme.spacing.footerHeight};
  hr {
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colors.auxiliary.green};
  }

  a:hover {
    opacity: 0.7;
  }

  .sitemap {
    height: 137px;
    padding-top: 2rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    > a {
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-right: ${({ hasButtonUp }) => hasButtonUp ? '0' : 'auto'};
    margin-left: ${({ hasButtonUp }) => hasButtonUp ? '0' : 'auto'};

    @media screen and (max-width: 700px) {
      margin-right: ${({ hasButtonUp }) => hasButtonUp ? 'auto' : '0'};
      margin-left: ${({ hasButtonUp }) => hasButtonUp ? 'auto' : '0'};
    }

    .links {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;
    }
    ul {
      display: flex;
      gap: 1.5rem;
    }
    li {
      height: 1.5rem;
      display: inline-block;
      &:last-child {
        margin-right: 0;
      }

      a {
        color: ${({ theme }) => theme.colors.gray.text_base};
      }
    }

    .social {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .icons {
        display: flex;
        gap: 1.5rem;
        flex-direction: row;
      }
      ul {
        li {
          height: 2rem;
          display: inline-block;
          &:last-child {
            a {
              margin-right: 0;
            }
          }
        }
      }

      span {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.gray.mid};
      }
    }
  }

  .arrowup, .arrow-up-mobile {
    border: 2px solid ${({ theme }) => theme.colors.secondary.health_green};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.385rem;
    cursor: pointer;
    transition: 0.2s;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
    background-color: #ffffff;

    svg {
      color: ${({ theme }) => theme.colors.secondary.health_green};
    }
  }

  .arrow-up-mobile {
    display: none;
  }

  @media screen and (max-width: 1020px) {
    padding: 1rem 2.5rem;

    .sitemap > a {
      display: none;
    }

    hr {
      display: none;
    }
    .menu ul {
      gap: 1rem;
    }

    .menu,
    .social {
      flex-direction: column;
      gap: 1.5rem;
      ul {
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;
      }
      li {
        height: auto;
        font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeSM};
        font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightNormal};
      }
      li a {
        color: ${({ theme }) => theme.colors.secondary.health_green};
        .social-span {
          display: flex;
          align-items: center;
          gap: 1.75rem;
        }
      }
    }
    .menu .social {
      flex-direction: column;
      gap: 3rem;
      align-items: flex-start;

      ul {
        flex-direction: row;

        li {
          margin-right: 0;
        }
      }

      span {
        padding-bottom: 1rem;
      }
    }
  }

  @media screen and (max-width: 675px) {
    padding: 0 0 1.5rem;
    background-color: unset;
    height: unset;

    hr {
      display: block;
      margin-bottom: 1.5rem;
    }

    .sitemap {
      height: unset;
      padding-top: unset;
      align-items: flex-end;
      > a:first-child {
        display: none;
      }
    }
    .menu {
      gap: 1.5rem;
      ul {
        gap: 1rem;
        li {
          margin-right: unset;
          a {
            font-weight: 400;
            line-height: 150%;
            color: #000000;
          }
        }
      }
    }
    .menu .social {
      flex-direction: column;
      align-items: flex-start;
      gap: 54px;
      ul {
        flex-direction: row;
      }
    }
    .mobile-only {
      display: none;
    }

    .icone {
      display: none;
    }
  }
  @media (max-width: 500px) {
    padding: 1.5rem 0;
  }
`;
